import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import * as actionTypes from '../../actions/actionTypes';
import { Main, BaseDialog } from '../../styles/common/Dialog';
import ColorSF2 from '../../styles/common/ColorSF2';

// TODO: ファイル分離
const Dialog = styled(BaseDialog)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const style = {
  contents: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30,
    marginBottom: 30,
  },
  body: {
    backgroundColor: ColorSF2.lightGray,
    width: 497,
    height: 240,
    padding: 8,
    overflowY: 'auto',
    marginBottom: 30,
  },
  closeButton: {
    cursor: 'pointer',
    backgroundColor: ColorSF2.white,
    border: `1px solid ${ColorSF2.mediumGray}`,
    width: 150,
    height: 44,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    padding: '0px 16px 0px 16px',
    marginBottom: 30,
  },
};

const createMessage = item => <p>{item}</p>;

/**
 * インポートエラーが発生した場合に表示されるダイアログ
 */
const ImportErrorDialog = () => {
  const dispatch = useDispatch();
  const errorMessages = useSelector(state => state.master.errorMessages);
  return (
    <Main
      id="closeConfirmEditMasterDialog"
      role="presentation"
      onClick={() => {
        dispatch({ type: actionTypes.CLOSE_IMPORT_ERROR_DIALOG });
      }}
    >
      <Dialog role="presentation" onClick={e => e.stopPropagation()}>
        <div style={style.header}>
          <FormattedMessage id="master.ImportErrorDialog.title.1" />
          <br />
          <FormattedMessage id="master.ImportErrorDialog.title.2" />
        </div>
        <div style={style.body}>
          {errorMessages && errorMessages.map(item => createMessage(item))}
        </div>
        <div style={style.contents}>
          <div
            className="button"
            role="presentation"
            id="closeButton"
            style={style.closeButton}
            onClick={() => {
              dispatch({ type: actionTypes.CLOSE_IMPORT_ERROR_DIALOG });
            }}
          >
            <FormattedMessage id="master.ImportErrorDialog.button.close" />
          </div>
        </div>
      </Dialog>
    </Main>
  );
};

export default injectIntl(ImportErrorDialog);
